import styled from 'styled-components/macro';

import ModalBase from '@components/common/core/DataDisplay/Modal';
import TextBase from '@components/common/core/DataDisplay/Text';
import ButtonBase from '@components/common/core/Inputs/Button';

export const Modal = styled(ModalBase)`
  width: 100%;
  max-width: 388px;
  box-sizing: border-box;
  padding: 24px;
`;

export const HeadingWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 16px;
`;

export const Heading = styled(TextBase)`
  color: ${({ theme }) => theme.colors.white.default};
  font-size: 1.125rem;
`;

export const Description = styled(TextBase)``;

export const Link = styled.a`
  text-decoration: none;
  color: ${({ theme }) => theme.colors.green.default};
`;

export const UnderstoodButton = styled(ButtonBase)`
  margin-top: 16px;
  margin-left: auto;
`;
